export function percent(value: number) {
  return `${value * 100}%`;
}
